import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { DateTime } from 'luxon';

export type ITimeSlot = {
  isNonBlocking?: boolean;
  start: DateTime;
  end: DateTime;
};

@Entity()
export class TimeSlot extends AdornisEntity {
  static override _class = 'TimeSlot';

  static override resolveID(entity: any): string {
    return (entity._id ||= A.getGloballyUniqueID());
  }

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => DateTime)
  start: Maybe<DateTime>;

  @Field(type => DateTime)
  end: Maybe<DateTime>;

  @Field(type => Boolean, { default: v => v ?? false })
  isNonBlocking!: boolean;
}
